import { instance } from "libs/api";

import { ApiRoutesWhatsAppAdProducts } from "../../constants";
import { IAdProduct } from "../../whatsappAdProducts.types";
import { UpsertAdProductBody } from "./upsertAdProduct.types";

export const requestUpsertAdProduct = async (
  body: UpsertAdProductBody
): Promise<IAdProduct> => {
  return await instance.post(ApiRoutesWhatsAppAdProducts.AdProducts, body);
};
